import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { RxCross1 } from "react-icons/rx";

/* --------- use case --------------
 1. context import 
   const {setConfirmationDoneUiRender} = useContext(CompRenderingContext);

  2. change the state in order to get the ui visiualisation
   setConfirmationDoneUiRender({
      isRender: true,
      type: "_ORDER_PLACED", 
   });
*/

export default function ConfirmationDoneUi({
  confrimationDoneUiRender,
  setConfirmationDoneUiRender,
}) {
  const { isRender, type } = confrimationDoneUiRender;

  const handleClose = () => {
    setConfirmationDoneUiRender({
      isRender: false,
      type: "",
    });
  };

  useEffect(() => {
    if (
      isRender &&
      (type === "_ORDER_PLACED" ||
        type === "_ORDER_CANCELLED" ||
        type === "_ORDER_RESCHEDULED" ||
        type === "_PAYMENT_DONE")
    ) {
      setTimeout(() => {
        handleClose();
      }, 2500);
    }
    // eslint-disable-next-line
  }, [isRender]);

  const data = {
    _ORDER_PLACED: {
      _bg_color: "white",
      text_color: "black",
      headText: "Yay! Order Placed",
      subHeadtext: "",
      quick_link: {
        text: "",
        url: "",
      },
    },
    _ORDER_CANCELLED: {
      _bg_color: "white",
      text_color: "black",
      headText: "Order Cancelled Successfully",
      subHeadtext: "",
      quick_link: {
        text: "",
        url: "",
      },
    },
    _ORDER_RESCHEDULED: {
      _bg_color: "white",
      text_color: "black",
      headText: "Order Rescheduled Successfully",
      subHeadtext: "",
      quick_link: {
        text: "",
        url: "",
      },
    },
    _PAYMENT_PENDING: {
      _bg_color: "white",
      text_color: "black",
      headText: "Payment Pending",
      subHeadtext:
        "We got an error while payment processing. If the amount has been deducted, it will be sent back to the source account.",
      quick_link: {
        text: "Raise a Query?",
        url: "/help",
      },
    },
    CART_PAYMENT_PENDING: {
      _bg_color: "white",
      text_color: "black",
      headText: "Payment Pending",
      subHeadtext:
        "Don't Worry, Order has been placed with 'COD mode'. If the amount has been deducted, it will be sent back to the source account.",
      quick_link: {
        text: "Raise a Query?",
        url: "/help",
      },
    },
    _PAYMENT_DONE: {
      _bg_color: "white",
      text_color: "black",
      headText: "Yay! Payment Received",
      subHeadtext: "",
      quick_link: {
        text: "",
        url: "",
      },
    },
    _PAYMENT_FAILED: {
      _bg_color: "white",
      text_color: "black",
      headText: "Payment Failed",
      subHeadtext: "",
      quick_link: {
        text: "Raise a Query?",
        url: "/help",
      },
    },
  };

  return (
    <AnimatePresence>
      {isRender && (
        <div
          onClick={handleClose}
          className="fixed top-0 tracking-[.6px] right-0 z-[99] left-0 bottom-0 flex items-center justify-center"
        >
          <motion.div
            initial={{ y: 600, width: "50%", opacity: 0 }}
            animate={{ y: 0, width: "100%", opacity: 1 }}
            exit={{ y: -600, opacity: 0, width: "150%" }}
            transition={{ ease: "easeOut", duration: 0.3 }}
            style={{
              backgroundColor: data[type]._bg_color,
              color: data[type].text_color,
            }}
            className="w-full h-full relative flex-col flex items-center justify-center"
          >
            <RxCross1 className="text-[black] text-[1.5rem] absolute top-4 right-4  " />
            <motion.div
              initial={{ y: 200, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: -200, opacity: 0 }}
              transition={{ ease: "easeOut", duration: 0.5, delay: 0.3 }}
            >
              <img src={imgUrls[type]} alt="order_placed_icon" />
            </motion.div>

            <motion.p
              initial={{ y: 200, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: -200, opacity: 0 }}
              transition={{ ease: "easeOut", duration: 0.5, delay: 0.5 }}
              className=" text-[1.5rem] w-[400px] max-w-[80vw] text-center font-[800]  "
            >
              {data[type].headText}
            </motion.p>
            <motion.p
              initial={{ y: 200, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: -200, opacity: 0 }}
              transition={{ ease: "easeOut", duration: 0.5, delay: 0.7 }}
              className=" text-[.825rem] w-[400px] max-w-[95vw] text-center text-[#525252] "
            >
              {data[type].subHeadtext}
            </motion.p>
            <motion.p
              initial={{ y: 200, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: -200, opacity: 0 }}
              transition={{ ease: "easeOut", duration: 0.5, delay: 0.9 }}
              className=" text-[.825rem] mt-8 text-[#2136d4] w-[400px] max-w-[95vw] text-center "
            >
              <Link to={"/help"} className=" text-[#2136d4] underline">
                {data[type].quick_link.text}
              </Link>
            </motion.p>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}

const imgUrls = {
  _ORDER_PLACED:
    "data:image/png;base64,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",
  _ORDER_CANCELLED: "https://img.icons8.com/fluency/144/cancel.png",
  _ORDER_RESCHEDULED:
    "data:image/png;base64,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",
  _PAYMENT_PENDING: "https://img.icons8.com/color/96/000000/error--v1.png",
  CART_PAYMENT_PENDING: "https://img.icons8.com/color/96/000000/error--v1.png",
  _PAYMENT_DONE: "https://img.icons8.com/ios-glyphs/120/000000/ok--v1.png",
  _PAYMENT_FAILED: "https://img.icons8.com/fluency/144/cancel.png",
};
